// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Phone from "@insite/mobius/Icons/Phone";
import { dealerInformationStyles } from "@tps/Overrides/Widgets/DealerDetails/DealerInformation";
import IconTextLinkArrowLeftInactive from "@tps/XDL/Icons/IconTextLinkArrowLeftInactive";
import { css } from "styled-components";

dealerInformationStyles.container = {
    gap: 10,
    css: css`
        padding-bottom: 15px;
    `,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsGridItem = {
    width: 12,
    css: css`
        padding-bottom: 15px;
    `,
};

dealerInformationStyles.nameGridItem = {
    width: 12,
    css: css`
        padding: 0 8px 0 35px;
    `,
};

dealerInformationStyles.nameText = {
    variant: "h2",
    ellipsis: true,
    css: css`
        margin-bottom: 15px;
    `,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: IconTextLinkArrowLeftInactive,
            size: 12,
            css: css`
                margin-right: 8px;
            `
        },
        position: "left",
    },
};

dealerInformationStyles.addressInfoIcon = {
    src: "MapPin",
    size: 20,
    color: "primary",
    css: css`
        &:not(:hover) {
            opacity: 0.66;
        }
    `,
};

dealerInformationStyles.phoneLink = {
    icon: {
        iconProps: {
            src: Phone,
            size: 20,
            css: css`
                &:not(:hover) {
                    opacity: 0.66;
                }
            `,
        },
        position: "left",
    },
    typographyProps: {
        size: 16,
    },
};

dealerInformationStyles.htmlContentGridItem = {
    width: 12,
    css: css`
        padding-left: 35px;
        padding-top: 15px;
    `,
};

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 12,
    css: css`
        padding-left: 35px;
    `,
};

dealerInformationStyles.googleMapsDirectionLink = {
    typographyProps: {
        size: 16,
    },
};

dealerInformationStyles.visitWebsiteLinkGridItem = {
    width: 12,
    css: css`
        padding-left: 35px;
    `,
};

dealerInformationStyles.visitWebsiteLink = {
    typographyProps: {
        size: 16,
    },
};
